import round from 'utils/round';
// eslint-disable-next-line import/no-extraneous-dependencies
import CryptoJS from 'crypto-js';
import {
  postGenererReferenciasBanco,
  postGenererReferenciasBancoV2,
  getReferenciaBancoPublic,
  banorteEncrypted,
} from 'api/recaudacion';
import gettersMap from 'api/padrones';
import _logger from 'utils/logger';
import { OAXACA, PROD } from 'utils/env';
import { propietarioToString } from 'utils/padronesToString';

const conceptEnum = {
  3: 2,
  31: 514,
};
const HMAC256Encrypt = ({ msg, key }) => {
  const cripto = CryptoJS.HmacSHA256(msg, key);
  return cripto.toString(CryptoJS.enc.Hex);
};

const BBVA = async (
  tipoDePadron,
  padron,
  _cargos,
  padrones,
  currentClassifier,
  descripcion,
  // eslint-disable-next-line default-param-last
  totalProp = 'adeudo_total',
  periodoFiscal,
  folio = null,
) => {
  let _referenciaFolio = null;

  if (folio === null) {
    _referenciaFolio = await postGenererReferenciasBancoV2({
      tipoDePadron,
      padron,
      cargosToReference: _cargos,
      padrones,
      cargos: _cargos,
      totalProp,
      periodoFiscal,
    });
  }

  const _referencia = await getReferenciaBancoPublic(
    folio || _referenciaFolio.folio,
    descripcion,
  );

  const padronRetrive = await gettersMap[tipoDePadron]({ id: (padron?.id || padron) });

  const n_contrib = padronRetrive?.empresa?.contribuyente?.nombre_completo
  || padronRetrive?.empresa?.contribuyente?.razon_social
  || padronRetrive?.empresa?.nombre_comercial
  || 'No definido';

  const nombre_comercial = currentClassifier
    ? `Impuesto de ${currentClassifier.nombre}`
    : (_cargos?.[0]?.descripcion || 'No definido');

  const s_dec = _referenciaFolio?.values?.description || nombre_comercial;

  const c_referencia = _referencia?.length > 0 ? _referencia[0].cadena_algoritmo : [];
  const importe = _cargos.reduce((acum, curr) => acum + curr[totalProp], 0);
  const t_importe = round(importe)[0].toFixed(2);

  const url = new URL('https://prepro.adquiracloud.mx/clb/endpoint/mgoax');
  // const url = new URL('https://www.adquiramexico.com.mx/clb/endpoint/mgoax');
  url.search = new URLSearchParams({
    s_transm: _referenciaFolio.folio_banco,
    c_referencia,
    t_servicio: '99',
    t_pago: '02',
    n_contrib,
    t_importe,
    s_dec,
    val_1: '0',
    val_2: '0',
  });

  return url.href;
};
const BBVAOAXACA = async (
  tipoDePadron,
  padron,
  _cargos,
  padrones,
  currentClassifier,
  descripcion,
  totalProp = 'adeudo_total',
) => {
  // https://www.adquiramexico.com.mx/clb/endpoint/mgoax
  const _referenciaFolio = await postGenererReferenciasBancoV2({
    tipoDePadron,
    padron,
    cargosToReference: _cargos,
    padrones,
    cargos: _cargos,
    totalProp,
  });

  const _referencia = await getReferenciaBancoPublic(
    _referenciaFolio.folio_banco,
    descripcion,
  );

  const n_contrib = ([1, 15].includes(tipoDePadron) ? padron?.nombre_completo
    : propietarioToString(padron, false)) || 'No definido';
    // 1010000085807
  // 1080000020378
  const mp_concept = conceptEnum?.[tipoDePadron];
  const mp_reference = _referencia?.length ? _referencia[0].cadena_algoritmo : null;
  const importe = _cargos.reduce((acum, curr) => acum + curr[totalProp], 0);
  const t_importe = round(importe)[0].toFixed(2);
  const hmac = '4fd4Ab23af10f38b5141310aJ68d24810890Cd45f06683fbBcb4d6804cf372aaa';
  const pre_hash = _referenciaFolio.folio_banco + mp_reference + t_importe;
  const mp_signature = HMAC256Encrypt({ msg: pre_hash, key: hmac });
  if (!mp_reference) return null;
  // const response = {
  //   mp_account: 2682,
  //   mp_node: 0,
  //   mp_product: 1,
  //   mp_concept,
  //   mp_order: _referenciaFolio.folio_banco,
  //   mp_reference,
  //   mp_customername: n_contrib,
  //   mp_amount: t_importe,
  //   mp_currency: 1,
  //   mp_urlsuccess: 'https://demosapi.migob.mx/configuracion/portal/',
  //   mp_urlfailure: 'https://demosapi.migob.gob.mx/configuracion/portal/',
  // };

  const url = new URL(PROD ? 'https://www.adquiramexico.com.mx/clb/endpoint/mgoax' : 'https://prepro.adquiracloud.mx/clb/endpoint/mgoax');
  url.search = new URLSearchParams({
    mp_account: PROD ? 2762 : 2682,
    mp_node: 0,
    mp_product: 1,
    mp_concept,
    mp_order: _referenciaFolio.folio_banco,
    mp_reference,
    mp_customername: n_contrib,
    mp_amount: t_importe,
    mp_currency: 1,
    mp_signature,
    mp_urlsuccess: PROD ? 'https://apitramites.migob.digital/configuracion/portal/' : 'https://demosapi.migob.mx/configuracion/portal/',
    mp_urlfailure: PROD ? 'https://apitramites.migob.digital/configuracion/portal/' : 'https://demosapi.migob.mx/configuracion/portal/',
  });

  return url.href;
};

const Santander = async (
  tipoDePadron,
  padron,
  _cargos,
  padrones,
  currentClassifier,
  descripcion,
  // eslint-disable-next-line default-param-last
  totalProp = 'adeudo_total',
  periodoFiscal,
  folio = null,
) => {
  let _referenciaFolio = null;
  if (folio === null) {
    _referenciaFolio = await postGenererReferenciasBancoV2({
      tipoDePadron,
      padron,
      cargosToReference: _cargos,
      padrones,
      cargos: _cargos,
      totalProp,
      periodoFiscal,
    });
  }

  const _referencia = await getReferenciaBancoPublic(
    folio || _referenciaFolio.folio,
    descripcion,
  );
  const referencia = _referencia?.length > 0 ? _referencia[0].cadena_algoritmo : [];
  const importe = _cargos.reduce((acum, curr) => acum + curr[totalProp], 0);
  const t_importe = round(importe)[0].toFixed(2);
  const convenio = _referencia[0]?.clave_convenio_de_operacion_de_receptor.split(
    'Convenio ',
  )[1] || '1288';

  const url = new URL(
    'https://www.santander.com.mx/Supernet2007/homeMicrositio.jsp',
  );
  url.search = new URLSearchParams({
    url_resp: 'https://haciendapruebas.migob.mx/',
    convenio,
    referencia,
    importe: t_importe,
  });

  return url.href;
};

const Banorte = async (
  tipoDePadron,
  padron,
  _cargos,
  padrones,
  currentClassifier,
  descripcion,
) => {
  const _referenciaFolio = await postGenererReferenciasBanco(
    tipoDePadron,
    padron,
    _cargos,
    padrones,
  );

  const _referencia = await getReferenciaBancoPublic(
    _referenciaFolio.folio_banco,
    descripcion,
  );
  const referencia = _referencia?.length > 0 ? _referencia[0].cadena_algoritmo : [];
  const importe = _cargos.reduce((acum, curr) => acum + curr.adeudo_total, 0);
  const t_importe = round(importe)[0].toFixed(2);

  const values = {
    mode: 'T',
    txCount: '1',
    responseUrl: 'https://hacienda.migob.mx/',
    txId1: referencia,
    concept1: `Impuesto de ${
      currentClassifier?.nombre || currentClassifier?.descripcion
    }`,
    clientId1: 'CHE0510161',
    reference1: referencia,
    amount: t_importe,
  };

  const encriptar = async () => {
    try {
      const response = await banorteEncrypted(values);
      if (response) {
        return response.data;
      }
      return null;
    } catch (error) {
      _logger(error);
      return null;
    }
  };

  const token = await encriptar();

  if (token) {
    return 'https://banorte.com/chequeelectronico2.0/?token=EiWZNCdNEENMfEqnoTzPfxWDhFzsiCEnnX+efH/v/5kWv+wWx6qBW2PMMqV8lkptN8pR+eKClxrRX2wsYJUFDasJC1oJRQGkRfn0OdM5Q44=';
  }

  return null;
};

const generateReferenceBank = {
  bbva: (...arg) => (OAXACA ? BBVAOAXACA(...arg) : BBVA(...arg)),
  santander: (...arg) => Santander(...arg),
  banorte: (...arg) => Banorte(...arg),
};

export default generateReferenceBank;
